import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/testing';

export const debug = createDebugger(prefix);
